import { render, staticRenderFns } from "./UserGroupsPage.vue?vue&type=template&id=e34d6dbc&scoped=true"
import script from "./UserGroupsPage.vue?vue&type=script&lang=js"
export * from "./UserGroupsPage.vue?vue&type=script&lang=js"
import style0 from "./UserGroupsPage.vue?vue&type=style&index=0&id=e34d6dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34d6dbc",
  null
  
)

export default component.exports